import styled, { css } from 'styled-components'
import { Colors, Shadows, Spacing } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import { Badge } from 'builder/components/Badge'
import Media from 'builder/styles/media'
import { TailoringFromPublicJobBoardHeader } from 'builder/components/DocumentEditor/TailoringFromPublicJobBoard'

export const Container = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-flow: column nowrap;
  background-color: ${Colors.Neutral10};
`

export const Content = styled.div<{ $isPreviewZoomed?: boolean }>`
  flex: 1 0 0;
  padding: 0 36px;
  overflow-y: auto;

  ${props =>
    props.$isPreviewZoomed &&
    css`
      overflow-y: unset;
      z-index: 2;
    `}

  ${Media.Phone`
    padding: 0 4px;
  `}
`

export const PreviewBox = styled.div`
  position: relative;
  margin: 16px auto;
  max-width: 559px;

  ${Media.Phone`
    margin: 4px auto;
    max-width: 100%;
  `}
`

export const MobilePaginationPanel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6px;

  ${Typography.Tiny};
  color: ${Colors.Neutral50};
  text-align: center;
`

export const MobilePaginationCounter = styled.div`
  display: inline-block;
  margin: 0 4px;
  font-variant-numeric: tabular-nums;
`

export const MobilePaginationButton = styled.div<{ isEnabled: boolean }>`
  display: inline-block;
  ${props =>
    !props.isEnabled &&
    css`
      cursor: unset;
      pointer-events: none;
      color: ${Colors.Neutral30};
    `}
`

export const MobilePaginationPrev = styled(MobilePaginationButton)`
  transform: scaleX(-1);
`

export const MobilePaginationNext = styled(MobilePaginationButton)``

export const TemplateLabel = styled(Badge).attrs({ size: 'medium', variant: 'neutral' })`
  position: absolute;
  z-index: 5;
  top: 8px;
  right: 8px;
  transform: translateZ(0);
`

export const EditorPanelSwitcherWrapper = styled.div<{
  $isHeaderShadowVisible: boolean
  $stickyTop: number
}>`
  background-color: ${Colors.White};
  padding: ${Spacing['2XS']} ${Spacing.XS};
  border-radius: 0 0 ${Spacing.XS} ${Spacing.XS};
  position: sticky;
  top: ${props => props.$stickyTop}px;
  z-index: 1;
  box-shadow: ${({ $isHeaderShadowVisible }) =>
    $isHeaderShadowVisible ? Shadows.lightWithBorderShadowLow : 'none'};
  transition: box-shadow 0.2s ease-out;
`

export const StyledTailoringFromPublicJobBoardHeader = styled(TailoringFromPublicJobBoardHeader)`
  position: sticky;
  top: 0;
  z-index: 1;
`
